import {
  CreateOtpRequestBody,
  ResetPasswordRequestBody,
  VerifyEmailRequestBody,
} from '@activepieces/ee-shared';
import {
  AuthenticationResponse,
  ClaimTokenRequest,
  FederatedAuthnLoginResponse,
  ProjectRole,
  SignInRequest,
  SignUpRequest,
  SwitchPlatformRequest,
  SwitchProjectRequest,
  ThirdPartyAuthnProviderEnum,
  SignInWithGoogleRequest,
  SignInWithKizeoRequest,
  SwitchTenantRequest,
} from '@activepieces/shared';

import { api } from '@/lib/api';

export const authenticationApi = {
  signIn(request: SignInRequest) {
    return api.post<AuthenticationResponse>(
      '/v1/authentication/sign-in',
      request,
    );
  },
  signUp(request: SignUpRequest) {
    return api.post<AuthenticationResponse>(
      '/v1/authentication/sign-up',
      request,
    );
  },
  getFederatedAuthLoginUrl(providerName: ThirdPartyAuthnProviderEnum) {
    return api.get<FederatedAuthnLoginResponse>(`/v1/authn/federated/login`, {
      providerName,
    });
  },
  me() {
    return api.get<ProjectRole | null>('/v1/project-members/role');
  },
  claimThirdPartyRequest(request: ClaimTokenRequest) {
    return api.post<AuthenticationResponse>(
      '/v1/authn/federated/claim',
      request,
    );
  },
  sendOtpEmail(request: CreateOtpRequestBody) {
    return api.post<void>('/v1/otp', request);
  },
  resetPassword(request: ResetPasswordRequestBody) {
    return api.post<void>('/v1/authn/local/reset-password', request);
  },
  verifyEmail(request: VerifyEmailRequestBody) {
    return api.post<void>('/v1/authn/local/verify-email', request);
  },
  switchProject(request: SwitchProjectRequest) {
    return api.post<AuthenticationResponse>(
      `/v1/authentication/switch-project`,
      request,
    );
  },
  switchPlatform(request: SwitchPlatformRequest) {
    return api.post<AuthenticationResponse>(
      `/v1/authentication/switch-platform`,
      request,
    );
  },
  switchTenant(request: SwitchTenantRequest) {
    return api.post<AuthenticationResponse>(
      `/v1/authentication/switch-tenant`,
      request,
    );
  },
  signInWithGoogle(request: SignInWithGoogleRequest) {
    return api.post<AuthenticationResponse>(
      '/v1/authentication/sign-in-with-google',
      request,
    );
  },
  signInWithKizeo(request: SignInWithKizeoRequest) {
    return api.post<AuthenticationResponse>(
      '/v1/authentication/sign-in-with-kizeo',
      request,
    );
  },
  signInWithKuser() {
    return api.post<AuthenticationResponse>(
      '/v1/authentication/sign-in-with-kuser',
      {},
    );
  },
  getCurrentKuserInfo() {
    return api.get<{ userId: string; isRegistered: boolean }>('/v1/authentication/current-kuser-info');
  },
  signOut() {
    return api.post<{ success: boolean }>('/v1/authentication/sign-out');
  },
  revokeAllSessions() {
    return api.post<{ success: boolean }>('/v1/authentication/revoke-all-sessions');
  },
};
